import './meal-deal-item-section-card.css';

import { IDataItem } from '../../../models/data.interface';
import { Util } from '../../../utils/util';
import { LocalizationService } from '../../../services/localization-service';

export class MealDealItemSectionCard {
    private readonly _localizationService: LocalizationService;
    private readonly _item: IDataItem;
    private readonly _element: HTMLElement;

    constructor(localizationService: LocalizationService, item: IDataItem, groupIndex: number, itemIndex: number, showOptions: boolean, orderItemKey?: number, func?: Function) {
        this._localizationService = localizationService;
        this._item = item;
        this._element = this._createElement(groupIndex, itemIndex, showOptions, orderItemKey);
        this._addClickHandler(func);
    }

    private _createElement(groupIndex: number, itemIndex: number, showOptions: boolean, orderItemKey?: number): HTMLElement {
        const name = this._localizationService.GetName(this._item.Names);
        const description = this._localizationService.GetDescription(this._item.Descriptions);
        let options = '';
        let selectedClass = '';
        if (showOptions && orderItemKey) {
            options = this._generateOptionsHtml(groupIndex, orderItemKey);
            selectedClass = "selected";

        } else {
            options = `<span class="button-link">${this._localizationService.names("AddToDeal")}</span>`;
        }

        const html = `
            <div id="div_meal_deal_items_item_${this._item.ItemId}" name="div_meal_deal_items_item" class="menu-item-card-small horizontal ${selectedClass}" data-id="${this._item.ItemId}" data-index="${itemIndex}">
                <div class="menu-item-card-small__image-container horizontal">
                    ${(this._item.ImageURL && this._item.ImageURL.trim() != "") ? `<img class="menu-item-card-small__image horizontal" src="${this._item.ImageURL}" alt="${name}">` : ""}
                </div>
                <div class="menu-item-card-small__label-container horizontal">
                    <div>
                        <span class="meal-deal-menu-item-card-small__label" ltagj="${Util.toLtagj(this._item.Names)}">${name}</span>
                        <span class="meal-deal-menu-item-card-small__label-desc ${selectedClass}" ltagj="${Util.toLtagj(this._item.Descriptions)}">${description}</span>
                    </div>
                    ${options}
                </div>
            </div>`;

        return Util.createHtmlElementFromTemplate(html);
    }

    private readonly _generateOptionsHtml = (groupIndex: number, orderItemKey: number): string => {
        return `
            <div class="menu-item-cart-card-actions">
                <div class="item-options">
                    <button id="btn_meal_deal_customize_${orderItemKey}" name="btn_meal_deal_customize" data-id="${orderItemKey}" data-groupid="${groupIndex}" class="button-link customize-btn" ltag="Customize">Customize</button>
                    <button id="btn_meal_deal_remove_${orderItemKey}" name="btn_meal_deal_remove" data-id="${orderItemKey}" data-groupid="${groupIndex}" class="button-link remove-btn" ltag="Remove">Remove</button>
                </div>
            </div>`;
    }

    public get element(): HTMLElement {
        return this._element;
    }

    private _addClickHandler(func?: Function): void {
        if (!func)
            return;

        Util.setElement("onclick", this._element, func);
    }
}